import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap-theme.css";
import "babel-polyfill";

import LoginPage from "./components/pages/login/login";
import { CircularProgress } from "material-ui";
import { Switch, Route, withRouter } from "react-router-dom";
import withWidth, { LARGE, SMALL } from "material-ui/utils/withWidth";
import React from "react";
import MenuHeader from "./services/menu-header";
import LogoutPage from "./components/pages/login/logout";
import UserHomePage from "./components/pages/admin/admin-home";
import PurchaseRequisitionPage from "./components/pages/paper/paper-page";
import AdministratorPage from "./components/pages/admin/administrator-page";
import ForbiddenAccess from "./components/pages/generics/forbidden-access";
import GenericNotFound from "./components/pages/generics/generic-not-found";
import Redirect from "react-router-dom/es/Redirect";
import * as AuthRole from "./general/auth-role";
import { connect } from "react-redux";
import { compose } from "recompose";
import * as LoginActionTypes from "./redux/action/login-action";
import * as RequisitionActions from "./services/paper-service";
import ErrorReporting from "material-ui-error-reporting";
import SettingsPage from "./components/pages/settings/settings-page";
import { Constants } from "./constants";
import ServerErrorPage from "./components/pages/generics/server-error-page";
import LeftDrawerContainer from "./components/menu/left-drawer-container";
import ReportsPage from "./components/pages/reports/reports-page";
import LandingPage from "./components/pages/landing/landing-page";
import ContractsPage from "./components/pages/contracts/ContractsPage";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      transitions: true,
      touch: true,
      shadow: true,
      pullRight: false,
      touchHandleWidth: 20,
      dragToggleDistance: 30,
      checkingLogin: false,
      redirectToForbidden: false,
      navDrawerOpen: true,
      navDrawerOpenPreviously: true,
      refreshCounter: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.width !== nextProps.width) {
      this.setState({
        navDrawerOpen: nextProps.width === LARGE,
        navDrawerOpenPreviously: nextProps.width === LARGE
      });
    }
  }

  componentDidMount() {
    if (this.props.location.pathname !== "/") {
      this.props.goGetUserDetails();
    }
  }

  handleChangeRequestNavDrawer = () => {
    let drawerOpened = !this.state.navDrawerOpen;
    this.setState({
      navDrawerOpen: drawerOpened,
      navDrawerOpenPreviously: drawerOpened
    });
  };

  onDialogVisible = visible => {
    if (visible) {
      this.setState({
        navDrawerOpen: false
      });
    } else {
      if (this.state.navDrawerOpenPreviously) {
        this.setState({
          navDrawerOpen: true
        });
      }
    }
  };

  afterPaperApproved = () => {
    this.setState({
      refreshCounter: true
    });
  };

  afterReportDetailsSaved = () => {
    this.setState({
      refreshCounter: true
    });
  };

  render() {
    let { navDrawerOpen } = this.state;
    const paddingLeftDrawerOpen = 236;

    const styles = {
      header: {
        paddingLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0
      },
      container: {
        left: 0,
        position: "absolute",
        margin: "20px 20px 50px 15px",
        width: "100%",
        paddingLeft:
          navDrawerOpen && this.props.width !== SMALL
            ? paddingLeftDrawerOpen
            : 0
      }
    };

    const username = this.props.firstName + " " + this.props.lastName;
    return (
      <div>
        <div>
          <ErrorReporting
            open={
              this.props.error.error ||
              (this.props.startUpFailed &&
                this.props.location.pathname !== "/login") ||
              false
            }
            action={this.props.error.action}
            error={
              this.props.startUpFailed &&
              this.props.location.pathname !== "/login"
                ? "Incarcarea paginii a eusuat. Va rog dati refresh!"
                : this.props.error.error
            }
          />
        </div>

        {this.props.startInProgress ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress size={100} />
          </div>
        ) : (
          <div>
            <Switch>
              <Route exact path="/login" render={props => <LoginPage />} />
              <Route
                path="/app/"
                render={props => (
                  <div>
                    <MenuHeader
                      styles={styles.header}
                      handleChangeRequestNavDrawer={
                        this.handleChangeRequestNavDrawer
                      }
                    />

                    <LeftDrawerContainer
                      user={this.props.user}
                      navDrawerOpen={navDrawerOpen}
                      username={username}
                      userEmail={this.props.userEmail}
                      refreshCounter={this.state.refreshCounter}
                    />

                    <div style={styles.container}>
                      <Route exact path="/app" component={UserHomePage} />
                      {AuthRole.isCompanyAdmin(this.props.userAuthRole) ? (
                        <Route
                          path="/app"
                          render={props => (
                            <AdministratorPage
                              {...props}
                              onDialogVisible={this.onDialogVisible}
                            />
                          )}
                        />
                      ) : null}

                      {this.props.user.isInApprovalFlow ? (
                        <Route
                          exact
                          path="/app/need-approval"
                          render={props => (
                            <PurchaseRequisitionPage
                              {...props}
                              removeAfterApproval={true}
                              needApprovalPage={true}
                              emptyDataText={"Nu aveti referate pentru semnat!"}
                              title={
                                "Referate ce necesita aprobarea dumneavoastra"
                              }
                              afterPaperApproved={this.afterPaperApproved}
                              onDialogVisible={this.onDialogVisible}
                              getData={page =>
                                RequisitionActions.getPapersForSigning()
                              }
                            />
                          )}
                        />
                      ) : null}

                      <Route
                        exact
                        path="/app/referate/:page"
                        render={props => (
                          <PurchaseRequisitionPage
                            {...props}
                            emptyDataText={
                              this.props.user.isInApprovalFlow
                                ? "Nu sunt referate!"
                                : "Nu aveti referate!"
                            }
                            title={
                              this.props.user.isInApprovalFlow
                                ? "Toate referatele de necesitate"
                                : "Referatele mele"
                            }
                            afterPaperApproved={this.afterPaperApproved}
                            onDialogVisible={this.onDialogVisible}
                            getData={(page, query) =>
                              RequisitionActions.getPapersForUser(page, query)
                            }
                          />
                        )}
                      />
                      <Route
                        exact
                        path={"/app/settings"}
                        component={SettingsPage}
                      />

                      {AuthRole.canSeeReports(this.props.user) && (
                        <Route
                          exact
                          path={"/app/reports/:page"}
                          render={props => (
                            <ReportsPage
                              {...props}
                              title={"Articole cumparate"}
                              afterReportDetailsSaved={
                                this.afterReportDetailsSaved
                              }
                              onDialogVisible={this.onDialogVisible}
                            />
                          )}
                        />
                      )}

                      {AuthRole.canSeeContracts(this.props.user) && (
                        <Route
                          exact
                          path={"/app/contracts"}
                          render={props => (
                            <ContractsPage
                              {...props}
                              onDialogVisible={this.onDialogVisible}
                            />
                          )}
                        />
                      )}
                    </div>
                  </div>
                )}
              />
              <Route exact path="/logout" render={props => <LogoutPage />} />
              <Route exact path="/forbidden" component={ForbiddenAccess} />
              <Route exact path="/notFound" component={GenericNotFound} />
              <Route exact path="/server-error" component={ServerErrorPage} />
              <Route exact path="/" render={props => <LandingPage />} />
              <Redirect to={"/notFound"} />
            </Switch>

            {this.props.startUpSuccessful &&
              this.props.location.pathname === "/server-error" && (
                <Redirect to={"/app/"} />
              )}

            {this.props.startUpFailed ? (
              !this.props.startInProgress &&
              localStorage.getItem(Constants.STORAGE_JWT_TOKEN_KEY) ? (
                <Redirect to={"/server-error"} />
              ) : (
                this.props.location.pathname !== "/" && (
                  <Redirect to={"/login"} />
                )
              )
            ) : null}
            {this.props.location.pathname !== "/" &&
              localStorage.getItem(Constants.STORAGE_JWT_TOKEN_KEY) ===
                null && <Redirect to={"/login"} />}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.login.user,
    userAuthRole: state.login.user.authRole,
    firstName: state.login.user.firstName,
    lastName: state.login.user.lastName,
    userEmail: state.login.user.email,
    startInProgress: state.startup.inProgress,
    startUpFailed: state.startup.startUpFailed,
    startUpSuccessful: state.startup.successful,
    error: state.errors.errors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goGetUserDetails: () => dispatch(LoginActionTypes.getUserData())
  };
}

export default withRouter(
  compose(
    connect(
      mapStateToProps,
      mapDispatchToProps
    ),
    withWidth()
  )(App)
);
